export function signinUsecaseFactory(deps) {
    return deps.authRepository.doRegister;
}
//# sourceMappingURL=signin.usecase.js.map